module.exports = __webpack_public_path__ + "img/zenfone9.d8c5db45.jpg";